{
  "phone": "N° de téléphone",
  "location": "Location",
  "complete": "Completez votre profil",
  "timezone": "Timezone",
  "accountHasBeenVerified": "Votre account a été verifié. Remplissez les champs suivants pour pouvoir utiliser l'application.",
  "start": "Commencer à utiliser",
  "done": "On boarding terminé",
  "use_now": "Vous pouvez desormais utiliser Otakus"
}
